import axios from "src/lib/axios";

// list find one
export const getUser = () => {
  return axios.get(`/user`);
};

// user list
export const getUserList = ({
  keyword = null,
  page = null,
  page_size = null,
  order_case = "desc",
}) => {
  return axios.get(`/users/members`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      order_case: order_case,
    },
  });
};

// user detail
export const getDetailUser = (id) => axios.get(`/users/detail/${id}`);

export const getAllUserList = async () => {
  const { data: response } = await axios.get(`/users/list`);
  return response.data;
};
